import { render, staticRenderFns } from "./miniPicture.vue?vue&type=template&id=6f88f407&scoped=true&"
import script from "./miniPicture.vue?vue&type=script&lang=js&"
export * from "./miniPicture.vue?vue&type=script&lang=js&"
import style0 from "./miniPicture.vue?vue&type=style&index=0&id=6f88f407&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f88f407",
  null
  
)

component.options.__file = "miniPicture.vue"
export default component.exports